import { render, staticRenderFns } from "./ChatRight.vue?vue&type=template&id=3072d38c&scoped=true&"
import script from "./ChatRight.vue?vue&type=script&lang=js&"
export * from "./ChatRight.vue?vue&type=script&lang=js&"
import style1 from "./ChatRight.vue?vue&type=style&index=1&id=3072d38c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072d38c",
  null
  
)

export default component.exports